import React, { PureComponent } from 'react';
import { NarrowLACard } from 'appSrc/components/List-Article/Cards';
import PropTypes from 'prop-types';
import { VariableLink } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class NarrowCardStack extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.narrowCardStack } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        { carousel.title &&
                            <div className={ 'carousel-title-bar ' + style.carouselTitleBar }>
                                <h2>{ carousel.title }</h2>
                            </div>
                        }
                        <div className={ style.set }>
                            { content.map( ( card, i ) => ( <NarrowLACard key={ i } item={ card } /> ) ) }
                        </div>
                        { carousel.link_url &&
                            <VariableLink to={ carousel.link_url } className={ style.link }>
                                { carousel.link_text || 'More in ' + carousel.title }
                            </VariableLink>
                        }
                    </div>
                }
            </div>
        );
    }
}
NarrowCardStack.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
NarrowCardStack.defaultProps = {
    className: '',
    carousel: {},
};

export default NarrowCardStack;
